import React, {useEffect, useState} from "react";
import {Card, Col, Row, Spinner, Button} from "reactstrap";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import ResponseOrgModel from "../../Org/Models/Response/ResponseOrgModel";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import {ADMIN_PATHS} from "../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {CheckDecimal} from "../../Common/Helpers/CheckDecimal";
import AdminRequestInternalTransaction from "../Models/Request/AdminRequestInternalTransaction";
import $ from "jquery";
import {CustomReload} from "../../AppSystem/Helpers/CustomReload";
import {InfoPageMessage} from "../../Common/Components/Button/InfoPageMessage";
import ResponseDigitalAccount from "../../DigitalAccount/Models/Response/ResponseDigitalAccount";
import {CardDigitalAccount} from "../../DigitalAccount/Components/CardDigitalAccount";
import {LoadingData} from "../../Common/Components/LoadingData";
import {SaveLocalStorage} from "../../Common/Helpers/SaveLocalStorage";
import {LoadLocalStorage} from "../../Common/Helpers/LoadLocalStorage";
import {FlashMessageInsufficientAccountAmount} from "../../Common/Helpers/FlashMessageInsufficientAccountAmount";
import { CheckUserPermission } from "../../AppSystem/Helpers/CheckUserPermission";
import { BsArrowLeftRight } from "react-icons/bs";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CustomModal } from "../../Common/Components/Modal/CustomModal";

export function AdminInternalTransactionsCreate() {
    const { t } = useTranslation();
    const { ApiCall } = useApiCallService();
    const navigate = useNavigate();

    const [requestInternalTransaction, setRequestInternalTransaction] = useState(new AdminRequestInternalTransaction());
    const [responseInternalTransaction, setResponseInternalTransaction] = useState(null);
    const [responseDigitalAccount, setResponseDigitalAccount] = useState(new ResponseDigitalAccount());
    const [responseDigitalAccountDestination, setResponseDigitalAccountDestination] = useState(new ResponseDigitalAccount());
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('internalTransaction.create'));
        setPageTitleKey('internalTransaction.create');
        setOnBack(null);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);


    const completeSchemaInternalTransaction = AdminRequestInternalTransaction.getAttributes( null, true);

    const [apiResponseOrg, setApiResponseOrg] = useState('');
    const [done, setDone] = useState(false);
    const [displaySpinner, setDisplaySpinner] = useState(false);
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [selectedDestinationOrg, setSelectedDestinationOrg] = useState(null);

    const [errorMessage, setErrorMessage] = useState('');

    const [amountToAdd, setAmountToAdd] = useState("");
    const [newBalance, setNewBalance] = useState("");
    const [activeField, setActiveField] = useState(null);
    
    const [showRefillModal, setShowRefillModal] = useState(false);
    const [refillAmount, setRefillAmount] = useState('');
    const [refillMessage, setRefillMessage] = useState('');
    const [leabOrgId, setLeabOrgId] = useState(null);

    let permissionRefill = false;
    if (CheckUserPermission("admin.internal-transaction.refill") || CheckUserPermission("admin.internal-transaction") || CheckUserPermission("admin")) {
        permissionRefill = true;
    }

    // GET ORGANIZATIONS FOR SELECT
    useEffect(() => {
        const handleApiResponse = (apiResponse) => {
                setApiResponseOrg(apiResponse);
                const leabOrg = apiResponse.items?.find(item => item.name === "LEAB");
                if (leabOrg) {
                    setLeabOrgId(leabOrg.id);
                }
        };
        const orgData = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/org/list-dropdown",
                };
                await ApiCall(apiCallOptions, handleApiResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        orgData();
    }, []);

    useEffect(() => {
        if (activeField !== 'amount') return;

        const stringValue = String(amountToAdd || '');
        const numericValue = parseFloat(stringValue.replace(',', '.')) || 0;
        
        if (numericValue > 0 && responseDigitalAccountDestination && responseDigitalAccountDestination.id) {
            const currentBalance = responseDigitalAccountDestination.availableBalance || responseDigitalAccountDestination.balance;
            const calculatedNewBalance = currentBalance + numericValue;
            const roundedNewBalance = Math.round(calculatedNewBalance * 100) / 100;
            setNewBalance(roundedNewBalance.toFixed(2).replace('.', ','));
            
            setRequestInternalTransaction((prevFormData) => ({
                ...prevFormData,
                amount: Math.round(numericValue * 100) / 100
            }));
        } else {
            setNewBalance('');
        }
    }, [amountToAdd, activeField, responseDigitalAccountDestination]);

    useEffect(() => {
        if (activeField !== 'newBalance') return;

        const stringValue = String(newBalance || '');
        const numericValue = parseFloat(stringValue.replace(',', '.')) || 0;
        
        if (numericValue > 0 && responseDigitalAccountDestination && responseDigitalAccountDestination.id) {
            const currentBalance = responseDigitalAccountDestination.availableBalance || responseDigitalAccountDestination.balance;
            const calculatedAmount = numericValue - currentBalance;

            const roundedAmount = Math.round(calculatedAmount * 100) / 100;
            
            if (roundedAmount >= 0) {
                const formattedAmount = roundedAmount.toFixed(2).replace('.', ',');
                setAmountToAdd(formattedAmount);
                
                setRequestInternalTransaction((prevFormData) => ({
                    ...prevFormData,
                    amount: roundedAmount
                }));
            } else {
                setAmountToAdd('0');
                setRequestInternalTransaction((prevFormData) => ({
                    ...prevFormData,
                    amount: 0
                }));
            }
        } else {
            setAmountToAdd('');
        }
    }, [newBalance, activeField, responseDigitalAccountDestination]);

    useEffect(() => {
        if(selectedDestinationOrg !== null){
            const handleDigitalAccountResponse = (responseApiDigitalAccount) => {
                if(responseApiDigitalAccount !== null) {
                    setResponseDigitalAccountDestination(responseApiDigitalAccount);
                    setAmountToAdd('');
                    setNewBalance('');
                    setActiveField(null);
                }
            };
            const DigitalAccountOrgDestinationApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/org/list-dropdown?orgId=" + selectedDestinationOrg + "&account=true",
                    };
                    await ApiCall(apiCallOptions, handleDigitalAccountResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            DigitalAccountOrgDestinationApiCall();
        }
    }, [selectedDestinationOrg]);

    let jsonOrg = {};
    if (apiResponseOrg !== null && apiResponseOrg !== '') {
        const orgArray = [];
        apiResponseOrg.items.forEach((item) => {
            const orgModel = new ResponseOrgModel(item);
            orgArray.push(orgModel);
        });
        jsonOrg = {
            orgId: orgArray,
        };
    }

    // CHECK IF THERE ARE LOCAL STORAGE VALUES
    useEffect(() => {
        const originOrgId = LoadLocalStorage('originOrgId');
        const message = LoadLocalStorage('message');
        if (originOrgId) {
            setSelectedOrg(originOrgId);
        }
        setRequestInternalTransaction((prevFormData) => ({
            ...prevFormData,
            originOrgId: originOrgId ?? '',
            message: message ?? ''
        }));
    },[apiResponseOrg]);

    // HANDLE CHANGE
    const handleChange = (e, name) => {
        let value;
        if (name === "originOrgId") {
            if (apiResponseOrg !== null && apiResponseOrg !== '') {
                apiResponseOrg.items.map(item => {
                    if (e.value !== undefined) {
                        if (item.id === e.value) {
                            setSelectedOrg(item.id);
                            if (item.name === "LEAB") {
                                SaveLocalStorage('originOrgId', item.id);
                            } else {
                                localStorage.removeItem('originOrgId');
                            }
                            value = e.value;
                        }
                    }
                })
            }
        }
        if (name === "destinationOrgId") {
            if (apiResponseOrg !== null && apiResponseOrg !== '') {
                apiResponseOrg.items.map(item => {
                    if (e.value !== undefined) {
                        if (item.id === e.value) {
                            setSelectedDestinationOrg(item.id);
                            value = e.value;
                        }
                    }
                })
            }
        }
        if (name === 'amount') {
            setActiveField('amount');
            if (e && e.target && e.target.value) {
                value = CheckDecimal(e.target.value);
                setAmountToAdd(String(value));
                setRequestInternalTransaction((prevFormData) => ({
                    ...prevFormData,
                    amount: parseFloat(String(value).replace(',', '.')) || 0
                }));
            } else {
                value = 0;
                setAmountToAdd('');
                setRequestInternalTransaction((prevFormData) => ({
                    ...prevFormData,
                    amount: 0
                }));
            }
            return; 
        }
        if (name === 'message') {
            if (e && e.target && e.target.value) {
                console.log("si")
                value = e.target.value;
                if (value !== "") {
                    SaveLocalStorage('message', value);
                } else {
                    localStorage.removeItem('message');
                }
            } else {
                localStorage.removeItem('message');
            }
        }
        if (name === 'subtype') {
            if (e && e.target && e.target.value) {
                value = e.target.value;
            }
        }
        if (name === 'newBalance') {
            setActiveField('newBalance');
            if (e && e.target && e.target.value) {
                value = CheckDecimal(e.target.value);
                setNewBalance(value);
            } else {
                setNewBalance('');
            }
            return;
        }
        setRequestInternalTransaction((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    }

    // HANDLE REFILL MODAL
    const handleOpenRefillModal = () => {
        setShowRefillModal(true);
        setRefillAmount('');
        setRefillMessage('');
    };

    const handleCloseRefillModal = () => {
        setShowRefillModal(false);
        setRefillAmount('');
        setRefillMessage('');
    };

    const handleRefillAmountChange = (e) => {
        let value;
        if (e && e.target && e.target.value) {
            value = CheckDecimal(e.target.value);
        } else {
            value = '';
        }
        setRefillAmount(value);
    };

    const handleRefillMessageChange = (e) => {
        setRefillMessage(e.target.value);
    };

    // HANDLE REFILL SUBMISSION
    const handleRefillSubmit = async () => {
        const numericAmount = refillAmount ? parseFloat(String(refillAmount).replace(',', '.')) : 0;
        
        if (!refillAmount || numericAmount <= 0) {
            handleCloseRefillModal();
            setTimeout(() => {
                FlashMessage(
                    t('validationMessage.greater0'),
                    'flash-messageError'
                );
            }, 300);
            return;
        }

        if (!leabOrgId) {
            handleCloseRefillModal();
            setTimeout(() => {
                FlashMessage(
                    t('validationMessage.leabNotFound'),
                    'flash-messageError'
                );
            }, 300);
            return;
        }

        const refillData = {
            amount: refillAmount,
            message: refillMessage || 'Påfyllning av virtuella medel.',
        };

        try {
            const apiCallOptions = {
                method: "post",
                url: "/internaltransaction/refill",
                data: refillData,
            };
            
            setDisplaySpinner(true);
            await ApiCall(apiCallOptions, (response) => {
                if (response) {
                    FlashMessage(
                        t('validationMessage.leabRefillSuccessfully'),
                        'flash-messageSuccess'
                    );
                    handleCloseRefillModal();
                    setTimeout(() => {
                        CustomReload(ADMIN_PATHS.INTERNAL_TRANSACTION);
                    }, 2000);
                }
            }, (error) => {
                FlashMessage(
                    t('validationMessage.leabRefillError'),
                    'flash-messageError'
                );
            });
        } catch (error) {
            console.log('Refill error:', error);
            FlashMessage(
                t('validationMessage.leabRefillError'),
                'flash-messageError'
            );
        } finally {
            setDisplaySpinner(false);
        }
    };

    // HANDLE VALIDATION
    const handleValidation = async () => {
        $('#submitInternalTransaction').prop('disabled', true);
        try {
            if (!requestInternalTransaction.subtype) {
            FlashMessage(
                t('internalTransaction.checkSubtype'),
                'flash-messageError'
            );
            $('#submitInternalTransaction').prop('disabled', false);
            return;
        }

        if (
            requestInternalTransaction.subtype === "Aktivitetsersättning" &&
            requestInternalTransaction.originOrgId &&
            requestInternalTransaction.destinationOrgId
        ) {
            const orgs = jsonOrg.orgId || [];
            const originOrg = orgs.find(org => org.id === requestInternalTransaction.originOrgId);
            const destOrg = orgs.find(org => org.id === requestInternalTransaction.destinationOrgId);

            const isOriginLokal = originOrg && originOrg.type && originOrg.type.toLowerCase().includes('lokal grupp');
            const isDestLokal = destOrg && destOrg.type && destOrg.type.toLowerCase().includes('lokal grupp');

            if (!isDestLokal) {
                FlashMessage(
                    t('internalTransaction.checkOrgsGroup'),
                    'flash-messageError'
                );
                $('#submitInternalTransaction').prop('disabled', false);
                return;
            }
        }
            if ($("#destinationError").hasClass('opacity-0')) {
                const roundedAmount = Math.round(requestInternalTransaction.amount * 100) / 100;
                const dataToSend = {
                    ...requestInternalTransaction,
                    amount: roundedAmount
                };
                
                await completeSchemaInternalTransaction.validate(dataToSend, {abortEarly: false});
                
                if (dataToSend && dataToSend.originOrgId !== "" && dataToSend.destinationOrgId !== "") {
                    if (dataToSend.message === "") {
                        dataToSend.message = null;
                    }
                    const apiCallOptions = {
                        method: "post",
                        url: "/internaltransaction/admin",
                        data: dataToSend,
                    };
                    try {
                        await ApiCall(apiCallOptions, setResponseInternalTransaction, setErrorMessage);
                        setDisplaySpinner(true);
                        setTimeout(() => {
                            setDone(true);
                        }, 1000);
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    // REDIRECT TO INFO PAGE
    useEffect(() => {
        if (done) {
            if (responseInternalTransaction) {
                FlashMessage(t('validationMessage.internalTransactionSuccessfully'), 'flash-messageSuccess');
                setTimeout(() => {
                    CustomReload(ADMIN_PATHS.INTERNAL_TRANSACTION);
                }, 2000);
            } else {
                if (errorMessage.includes("{")) {
                    FlashMessage(<FlashMessageInsufficientAccountAmount jsonString={errorMessage} />, 'flash-messageError', 10000, true);
                    $('#submitInternalTransaction').prop('disabled', false);
                }
                else {
                    FlashMessage(t('validationMessage.organizationNotMoney'), 'flash-messageError');
                    $('#submitInternalTransaction').prop('disabled', false);
                }
            }
            setDone(false);
            setDisplaySpinner(false);
            setErrorMessage('');
        }
    }, [done]);

    //GET DIGITAL ACCOUNT BY ID ORG
    useEffect(() => {
        if(selectedOrg !== null){
        const handleDigitalAccountResponse = (responseApiDigitalAccount) => {
            if(responseApiDigitalAccount !== null) {
                setResponseDigitalAccount(responseApiDigitalAccount);
            }
        };
        const DigitalAccountOrgApiCall = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/org/list-dropdown?orgId=" + selectedOrg + "&account=true",
                };
                await ApiCall(apiCallOptions, handleDigitalAccountResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        DigitalAccountOrgApiCall();
          }

    }, [selectedOrg]);

    useEffect(() => {
        if(selectedDestinationOrg !== null){
            const handleDigitalAccountResponse = (responseApiDigitalAccount) => {
                if(responseApiDigitalAccount !== null) {
                    setResponseDigitalAccountDestination(responseApiDigitalAccount);
                }
            };
            const DigitalAccountOrgDestinationApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/org/list-dropdown?orgId=" + selectedDestinationOrg + "&account=true",
                    };
                    await ApiCall(apiCallOptions, handleDigitalAccountResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            DigitalAccountOrgDestinationApiCall();
        }

    }, [selectedDestinationOrg]);

    const attributes = AdminRequestInternalTransaction.getAttributes(
        null,
        null,
        jsonOrg,
        { 
            originOrgId: requestInternalTransaction.originOrgId,
            destinationOrgId: requestInternalTransaction.destinationOrgId
         }
    );

    const modalRefillContent = (
        <>
            <div className="mb-3 d-flex align-items-center justify-content-center">
                <i className="bx bx-dollar-circle me-2 text-success"></i>
                <h5 className="mb-0">{t('internalTransaction.refillLeabTitle')}</h5>
            </div>

            <div className="mb-3">
                <p className="text-muted mb-0">
                    {t('internalTransaction.refillLeabModalDescription')}
                </p>
            </div>

            <div className="mb-3">
                <CustomInput
                    model={AdminRequestInternalTransaction}
                    attribute='amount'
                    data={refillAmount}
                    customChange={handleRefillAmountChange}
                    isInternalTranssaction='true'
                />
            </div>

            <div className="mb-3 text-start">
                <label className="form-label">
                    {t('modelLabel.message')} ({t('optional')})
                </label>
                <textarea
                    className="form-control"
                    value={refillMessage}
                    onChange={handleRefillMessageChange}
                    placeholder={t('formPlaceholder.enterComment')}
                    rows="3"
                />
            </div>

            <InfoPageMessage message={t('internalTransaction.refillLeabNote')} />
        </>
    );

    const modalRefillFooter = (
        <>
            <Button className="box-red border-0" onClick={handleCloseRefillModal}>
                {t('button.cancel')}
            </Button>
            <Button
                className="box-green border-0"
                onClick={handleRefillSubmit}
                disabled={displaySpinner}
            >
                {displaySpinner ? (
                    <>
                        <Spinner size="sm" className="me-2" />
                        {t('button.processing')}
                    </>
                ) : (
                    <>
                        <i className="bx bx-check me-1"></i>
                        {t('button.confirm')}
                    </>
                )}
            </Button>
        </>
    );

    return(
        <>
            <Col lg={6} className="mb-5 ps-0">
                <Card className="card-backend p-4">
                    <Row className="align-items-center">
                        <Col xs='auto'>
                            <h2 className='rokkitt-font mb-0'>{t('internalTransaction.create')}</h2>
                        </Col>
                        <InfoPageMessage message={t('infoBox.internalTransaction')}/>
                        
                    </Row>
                    {permissionRefill === true && (
                        <div className="justify-content-end d-flex">
                            <Button 
                                color="success"
                                onClick={handleOpenRefillModal}
                                className="btn-submit-kassan d-flex align-items-center"
                            >
                                <i className="bx bx-plus-circle me-2"></i>
                                {t('button.refill')}
                            </Button>
                        </div>
                    )}
                    <Row>
                        {apiResponseOrg !== '' && apiResponseOrg !== null ?
                            <>
                                <Col lg={6}>
                                    <CustomInput model={AdminRequestInternalTransaction} attribute='originOrgId' data={requestInternalTransaction.originOrgId} customChange={(e) => handleChange(e, 'originOrgId')} customOptions={jsonOrg} />
                                    {responseDigitalAccount.id !== '' ?
                                        <CardDigitalAccount data={responseDigitalAccount}/>
                                        : ''}
                                </Col>
                                <Col lg={6} className="position-relative">
                                    <CustomInput model={AdminRequestInternalTransaction}
                                                 attribute='destinationOrgId' data={''}
                                                 customChange={(e) => handleChange(e, 'destinationOrgId')}
                                                 customOptions={jsonOrg}/>

                                    <div id="destinationError" className={`error tooltip-custom-normal ${requestInternalTransaction.originOrgId !== "" && requestInternalTransaction.destinationOrgId !== "" && requestInternalTransaction.originOrgId === requestInternalTransaction.destinationOrgId ? 'opacity-1' : 'opacity-0'}`}
                                        style={{color: '#f56e6e'}}>
                                        {t('validationMessage.sameOrg')}
                                    </div>
                                    {responseDigitalAccountDestination.id !== '' ?
                                        <CardDigitalAccount data={responseDigitalAccountDestination}/>
                                    : ''}
                                </Col>
                                <Col lg={12}>
                                    <Row className="align-items-center gx-3 my-3 internal-amount-row">
                                        <Col>
                                            <CustomInput
                                                model={AdminRequestInternalTransaction}
                                                attribute="amount"
                                                data={amountToAdd}
                                                customChange={(e) => handleChange(e, 'amount')}
                                                isInternalTranssaction='true'
                                            />
                                        </Col>

                                        <Col xs="auto" className="d-flex justify-content-center align-items-center px-2">
                                            <div style={{ width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <BsArrowLeftRight size={22} color="green" />
                                            </div>
                                        </Col>

                                        <Col>
                                            <CustomInput
                                                model={AdminRequestInternalTransaction}
                                                attribute="newBalance"
                                                data={newBalance}
                                                customChange={(e) => handleChange(e, 'newBalance')}
                                                placeholder={t('internalTransaction.newBalancePlaceholder')}
                                                inputClassName="form-control form-control-lg"
                                                label={t('internalTransaction.newBalance') + ':'}
                                                isInternalTranssaction='true'
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6}>
                                    <CustomInput model={AdminRequestInternalTransaction} attribute='subtype' data={requestInternalTransaction.subtype}
                                                 customChange={(e) => handleChange(e, 'subtype')}
                                                 customOptions={{ subtype: attributes.subtype.form.options }} />
                                </Col>
                                <Col lg={6} className="position-relative">
                                    <i className="bx bx-x fs-4 position-absolute end-0 pt-4 mt-3 z-3 me-3" onClick={() => {
                                        setRequestInternalTransaction((prevFormData) => ({
                                            ...prevFormData,
                                            message: ""
                                        }));
                                        localStorage.removeItem('message');
                                    }}/>
                                    <CustomInput model={AdminRequestInternalTransaction} attribute='message' data={requestInternalTransaction.message}
                                                 customChange={(e) => handleChange(e, 'message')}/>
                                </Col>
                                <Col lg={12} className="text-end">
                                    {displaySpinner === true ?
                                        <>
                                            {t('validationMessage.sendingInternalTransaction')} <Spinner color='success' className="me-3" />
                                        </>
                                        : ""}
                                    <CustomSubmitButton text={t('button.send')} id='submitInternalTransaction' icon='bx bx-send pe-2' customClick={handleValidation} />
                                </Col>
                            </>
                            :
                            <LoadingData data={apiResponseOrg}/>
                        }
                    </Row>
                </Card>
            </Col>

            {/* Modal de Recarga LEAB */}
            <CustomModal
                isOpen={showRefillModal}
                toggle={handleCloseRefillModal}
                body={modalRefillContent}
                footer={modalRefillFooter}
                size={'md'}
            />
        </>
    )
}